<app-page-content [enableMenuButton]="true">
  <span pagetitle>Brukere</span>
  <div pagecontent>
    <app-user-table *ngIf="!coreConfiguration.isMobile" [users]="users" (editUser)="editUser($event)"></app-user-table>

    <app-list *ngIf="coreConfiguration.isMobile" [maxCount]="50" [totalCount]="totalUserCount">
      <app-user-list-item *ngFor="let item of users" [user]="item" (click)="editUser(item)"></app-user-list-item>
    </app-list>
  </div>

  <div style="display: flex" pagefooter>
    <app-button-box style="margin: auto">
      <button mat-raised-button color="primary" (click)="newUser()" *ngIf="session.userMaintenanceIsAllowed()">NY BRUKER</button>
    </app-button-box>

    <span style="flex: 1 1 auto"></span>

    <app-paginator [totalCount]=totalUserCount
                   [pageSize]="20"
                   [pageIndex]=currentPage
                   [enablePageSizeSelector]="false"
                   (page)="changePage($event)">
    </app-paginator>
  </div>
</app-page-content>
